module.exports = __webpack_public_path__ + "static/img/org_title20.176bb35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title20.png
// module id = Paw/
// module chunks = 4